import moment from "moment";

export function getIdadeFormatada(date?: string | Date | null): string {
  if (!date) return "0 anos";

  const nascimento = moment(date);
  if (!nascimento.isValid()) return "0 anos";

  const mesesTotais = moment().diff(nascimento, "months");

  if (mesesTotais < 12) {
    return `${mesesTotais} ${mesesTotais === 1 ? "mês" : "meses"}`;
  }

  const anosExatos = mesesTotais / 12;
  return `${anosExatos.toFixed(1)} anos`; // arredonda para 1 casa decimal
}
